export default "__VITE_ASSET__c3m58c82__"